import React from "react"
import PropTypes from "prop-types"

const NonStretchedImage = (props) => {
  // let normalizedProps = props
  // if (props.extension === "gif" || props.extension === "svg") {
  //   return (
  //     <img
  //       style={{ width: "100%", height: "100%", margin: "0" }}
  //       alt={props.alt}
  //       src={props.SlugifiedPublicUrl}
  //     />
  //   )
  // }
  // if (props.childImageSharp?.fluid?.presentationWidth) {
  //   normalizedProps = {
  //     ...props,
  //     childImageSharp: {
  //       ...props.childImageSharp,
  //       style: {
  //         ...(props.childImageSharp.style || {}),
  //         maxWidth: props.childImageSharp.fluid.presentationWidth,
  //         height: props.childImageSharp.fluid.presentationHeight,
  //         margin: `0 ${props.childImageSharp.style.marginRight || "auto"} 0 ${
  //           props.childImageSharp.style.marginLeft || "auto"
  //         }`,
  //       },
  //     },
  //   }
  // }
  // return <Img {...normalizedProps.childImageSharp} />
  return (
    <img
      className={props.className}
      style={props.style === undefined ? { margin: "0" } : props.style}
      alt={props.alt}
      src={props.SlugifiedPublicUrl}
      role={props.role}
      aria-hidden={props.ariaHidden}
    />
  )
}

//-----------------------Prop-Types---------------------------//

NonStretchedImage.propTypes = {
  extension: PropTypes.string,
  alt: PropTypes.string,
  SlugifiedPublicUrl: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  ariaHidden: PropTypes.bool,
  role: PropTypes.string,
}

//-----------------------Prop-Types---------------------------//

export default NonStretchedImage
